'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get4 = require('babel-runtime/helpers/get');

var _get5 = _interopRequireDefault(_get4);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _get6 = require('lodash/get');

var _get7 = _interopRequireDefault(_get6);

var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ClientSideComponent = require('core/ClientSideComponent');

var _ClientSideComponent2 = _interopRequireDefault(_ClientSideComponent);

var _reactRedux = require('react-redux');

var _Modal = require('react-bootstrap/lib/Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _project = require('redux/modules/project');

var projectActions = _interopRequireWildcard(_project);

var _reactI18next = require('react-i18next');

var _components = require('components');

var _auth = require('redux/modules/auth');

var _toastr = require('helpers/toastr');

var _toastr2 = _interopRequireDefault(_toastr);

var _uploads = require('helpers/uploads');

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var ReplaceMediaFile = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    submittedMediaReplaceFile: state.project.submittedMediaReplaceFile
  };
}, (0, _extends3.default)({}, projectActions, { logout: _auth.logout }), null, { withRef: true }), _dec2 = (0, _reactI18next.translate)(['common'], { withRef: true }), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(ReplaceMediaFile, _Component);

  function ReplaceMediaFile() {
    var _ref;

    (0, _classCallCheck3.default)(this, ReplaceMediaFile);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = ReplaceMediaFile.__proto__ || (0, _getPrototypeOf2.default)(ReplaceMediaFile)).call.apply(_ref, [this].concat(args)));

    _this._uploaderOnSubmitted = function (id) {
      _this.props.submitMediaReplaceFile(id);
    };

    _this._uploaderOnComplete = function (id, name, resp) {
      var code = resp.code,
          success = resp.success;
      var _this$props = _this.props,
          replaceMedia = _this$props.replaceMedia,
          projectId = _this$props.projectId,
          t = _this$props.t;
      var media = _this.state.media;


      if (code === 1) {
        return _this.props.logout();
      }

      var data = (0, _get7.default)(resp, 'data[0]');
      if (data) {
        replaceMedia(data, projectId, media.id);
        _this.setState({ media: data });
      }

      if (success) {
        _toastr2.default.success(t('Media file successfully replaced'));
      }
    };

    _this._mountUploader = function () {
      var FineUploaderTraditional = require('components/FineUploader/traditional');
      var postParams = _this.state.postParams;


      _this.uploader = new FineUploaderTraditional({
        request: { params: postParams },
        chunking: { success: { endpoint: '/api/FileUpload_wa/uploadAudioVideo' } }
      });

      _this.uploader.on('submitted', _this._uploaderOnSubmitted);
      _this.uploader.on('complete', _this._uploaderOnComplete);
    };

    _this._unMountUploader = function () {
      _this.uploader.off('submitted', _this._uploaderOnSubmitted);
      _this.uploader.off('complete', _this._uploaderOnComplete);
      _this.uploader.methods.cancelAll();
      _this.uploader = null;
    };

    _this.state = { show: false };
    _this.uploader = null;
    return _this;
  }

  (0, _createClass3.default)(ReplaceMediaFile, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      (0, _get5.default)(ReplaceMediaFile.prototype.__proto__ || (0, _getPrototypeOf2.default)(ReplaceMediaFile.prototype), 'componentDidMount', this).call(this, this._mountUploader);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      (0, _get5.default)(ReplaceMediaFile.prototype.__proto__ || (0, _getPrototypeOf2.default)(ReplaceMediaFile.prototype), 'componentWillUnmount', this).call(this, this._unMountUploader);
    }
  }, {
    key: 'show',
    value: function show(params) {
      this.setState((0, _extends3.default)({ show: true }, params));
      var media = params.media,
          postParams = params.postParams;

      this.uploader.methods.setParams((0, _extends3.default)({}, postParams, { replacedId: media.id, part: media.part }));
    }
  }, {
    key: 'hide',
    value: function hide() {
      this.setState({ show: false });
      this.uploader.methods.cancelAll();
      this.props.initSubmittedReplaceFile();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          submittedMediaReplaceFile = _props.submittedMediaReplaceFile,
          onDropError = _props.onDropError,
          className = _props.className,
          projectType = _props.projectType;
      var _state = this.state,
          show = _state.show,
          title = _state.title,
          message = _state.message,
          isMounted = _state.isMounted;

      var mediaSupportedFormats = (0, _uploads.getUploaderAcceptableFormats)(projectType);

      return _react2.default.createElement(
        _Modal2.default,
        { show: show, onHide: this.hide, className: className },
        title && _react2.default.createElement(
          _Modal2.default.Header,
          null,
          _react2.default.createElement(
            _Modal2.default.Title,
            null,
            title
          )
        ),
        _react2.default.createElement(
          _Modal2.default.Body,
          null,
          message && _react2.default.createElement(
            'h4',
            null,
            message
          ),
          isMounted && _react2.default.createElement(
            _components.UploadArea,
            {
              uploader: this.uploader,
              submittedFiles: submittedMediaReplaceFile,
              multiple: false,
              accept: mediaSupportedFormats,
              onDropError: onDropError
            },
            _react2.default.createElement(
              'div',
              { className: 'hint small' },
              _react2.default.createElement(
                'div',
                null,
                t('Supported file formats: {{formats}}', { formats: mediaSupportedFormats })
              ),
              _react2.default.createElement(
                'div',
                null,
                t('Upload the new file')
              )
            )
          )
        ),
        _react2.default.createElement(
          _Modal2.default.Footer,
          null,
          _react2.default.createElement(
            'button',
            { className: 'btn btn-accent', onClick: this.hide },
            t('Close')
          )
        )
      );
    }
  }]);
  return ReplaceMediaFile;
}(_ClientSideComponent2.default), _class3.propTypes = {
  className: _propTypes2.default.string,
  initSubmittedReplaceFile: _propTypes2.default.func,
  logout: _propTypes2.default.func,
  onDropError: _propTypes2.default.func,
  projectId: _propTypes2.default.number.isRequired,
  projectType: _propTypes2.default.string.isRequired,
  replaceMedia: _propTypes2.default.func,
  submitMediaReplaceFile: _propTypes2.default.func,
  submittedMediaReplaceFile: _propTypes2.default.array,
  t: _propTypes2.default.func
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'hide', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'hide'), _class2.prototype)), _class2)) || _class) || _class);
exports.default = ReplaceMediaFile;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ReplaceMediaFile/ReplaceMediaFile.js
// module id = 2094
// module chunks = 1